<div style="background-color: white; height: calc(100% - 100px);">				
    <div style="width: 100%; padding: 1em;">
        <div *ngIf="isLoading" class="loading-shade">
            <mat-spinner></mat-spinner>
        </div>
        <table mat-table [dataSource]="dataSourceNeedsCoApp" *ngIf="!isLoading" class="mat-elevation-z8 demo-table">
            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"><a target="_self"
                        [routerLink]="['/applications/summary', element.id]"
                        [queryParams]="{ dealname: element.Deal_Name }">{{element.Deal_Name}}</a>  </td>
            </ng-container>

            <!-- Province Column -->
            <ng-container matColumnDef="province">
                <th mat-header-cell *matHeaderCellDef> Province </th>
                <td mat-cell *matCellDef="let element"> {{element.Province}} </td>
            </ng-container>

            <!-- Province Column -->
            <ng-container matColumnDef="agencyName">
                <th mat-header-cell *matHeaderCellDef> Agency </th>
                <td mat-cell *matCellDef="let element"> {{element.Agency_Formula}} </td>
            </ng-container>

            <!-- Modified Time Column -->
            <ng-container matColumnDef="note">
                <th mat-header-cell *matHeaderCellDef> Most Recent Note </th>
                <td mat-cell *matCellDef="let element"> {{element.Reason_for_Poor_credit_score}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="ncpColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: ncpColumns;" class="element-row"></tr>
        </table>	
        <mat-paginator #paginator [length]="1000" [pageSize]="10"></mat-paginator>
    </div>
</div>
